import type { LucideIcon } from 'lucide-react';
import { baseIcons } from './registryBase';
import { domainIcons } from './registryDomain';

export const iconRegistry: Record<string, LucideIcon> = {
  ...baseIcons,
  ...domainIcons,
};

export type IconName = keyof typeof iconRegistry;
